<template>
  <div>
    <div class="btn-btn">
      <b-button squared class="two" :to="{ name: 'programaGobierno' }"  >Asociados al Programa de Gobierno</b-button>
      <b-button squared class="one" disabled >Resultados de Productos Estratégicos</b-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    seleccionar(nombre) {
      this.$router.push({ name: nombre });
    },
  },
};
</script>

<style scoped>
.btn-btn {
  margin-left: 80px;
}

.one {
  background: #e0e0e0 !important;
  color: #052333 !important;
  border: none;
  font-weight: 700 !important;
  max-width: 186px;
  max-height: 70px;
  font-size: 12px;
}

.one:hover {
  background: #f5f5f5;
  color: #052333;
}

.two {
  color: #b1b1b1;
  background: #fff;
  border: none;
  max-width: 186px;
  max-height: 70px;
  font-size: 12px;
}

.two:hover {
  background: #fff;
  color: #b1b1b1;
}

@media screen and (max-width: 767px) {
  .btn-btn {
    margin-left: 90px;
  }
}

@media screen and (max-width: 491px) {
  .btn-btn {
    margin-left: 30px;
  }
}
</style>

